import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import DashboardLayout from '@/components/DashboardLayout';
import Dashboard from '@/pages/Dashboard';
import WhatsAppConnection from '@/pages/WhatsAppConnection';
import CoachManagement from '@/pages/CoachManagement';
import Groups from '@/pages/Groups';
import Reports from '@/pages/Reports';

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="whatsapp" element={<WhatsAppConnection />} />
            <Route path="coaches" element={<CoachManagement />} />
            <Route path="groups" element={<Groups />} />
            <Route path="reports" element={<Reports />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" richColors />
    </div>
  );
}

export default App;
